module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/087-aland-islands-0335c2ee55abaaefa5ed76bfa0a490e9.svg";